import React, { Component } from 'react';
import { Translate } from 'react-redux-i18n';


class MarketingModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: null,
      sortColumn: null,
      sortDirection: null,
      data:[],
    };
  }

  componentDidMount() {
    this.setState({
      data: this.props.all
    })
  }

  render() {
    return (
      <div style={{display:'flex', flexDirection:'column', overflow:'scroll', height: '300px'}}>
        {this.props.canSelectAll && this.props.all.length > 0 && <div style={{display:'flex', flexDirection:'row', margin:10}}>
            <input type="checkbox" value={'all'} checked={this.props.checkedAll} name="marketingId" onChange={(event)=>{
              this.props.update(event.target.value, event.target.checked)
            }}/>
            <span style={{fontSize:16 }}><Translate value="all" /></span>
          </div>}
        {this.props.all.length > 0 && this.props.all.map((item) => {
          if(item.level == 0) {
            return<div style={{display:'flex', flexDirection:'row', margin:10}}>
            <input type="checkbox" value={item.id} checked={item.checked} name="marketingId" onChange={(event)=>{
              this.props.enableSelect && this.props.update(event.target.value, event.target.checked)
            }}/>
            <span style={{fontSize:16 }}>{item.Name}</span>
          </div>
          } else {
            return <div key={item.id} style={{display:'flex', flexDirection:'row', margin:10, paddingLeft:30}}>
            <input type="checkbox" value={item.id} checked={item.checked} name="marketingId" onChange={(event)=>{
              this.props.enableSelect && this.props.update(event.target.value, event.target.checked)
            }}/>
            <span style={{fontSize:16 }}>{item.Name}</span>
          </div>
          }
        })}
      </div>
    );
  }
}

export default MarketingModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Products/components/MarketingModal.jsx